export const sourceTypeEnum = {
  AMAZON_S3: '1',
  WEB_FOLDER: '2',
  CLOUDINARY_BACKUP: '3',
  GOOGLE_CLOUD_STORAGE: '5',
  AZURE: '6',
  S3_COMPATIBLE_STORAGE: '7', // Only for react frontend - does not go to backend
  WEB_PROXY: '8', // Only for react frontend - does not go to backend
  AKENEO_PIM: '9'
}

export const sourceTextMapping = {
  [sourceTypeEnum.AMAZON_S3]: 'Amazon S3',
  [sourceTypeEnum.CLOUDINARY_BACKUP]: "Cloudinary's Backup Bucket",
  [sourceTypeEnum.S3_COMPATIBLE_STORAGE]:
    'S3-Compatible Storage (Wasabi, Digital Ocean Spaces, Ali Storage, etc.)',
  [sourceTypeEnum.GOOGLE_CLOUD_STORAGE]: 'Google Cloud Storage',
  [sourceTypeEnum.AZURE]: 'Azure Storage',
  [sourceTypeEnum.WEB_FOLDER]:
    'Web Folder - HTTP(S) server and Magento, Shopify, Wordpress, etc.',
  [sourceTypeEnum.WEB_PROXY]: 'Web Proxy',
  [sourceTypeEnum.AKENEO_PIM]: 'Akeneo PIM'
}

export const originCategory = {
  s3Types: [
    {
      text: sourceTextMapping[sourceTypeEnum.AMAZON_S3],
      typeId: sourceTypeEnum.AMAZON_S3,
    },
    {
      text: sourceTextMapping[sourceTypeEnum.CLOUDINARY_BACKUP],
      typeId: sourceTypeEnum.CLOUDINARY_BACKUP,
    },
    {
      text: sourceTextMapping[sourceTypeEnum.S3_COMPATIBLE_STORAGE],
      typeId: sourceTypeEnum.S3_COMPATIBLE_STORAGE,
    },
  ],
  google: [
    {
      text: sourceTextMapping[sourceTypeEnum.GOOGLE_CLOUD_STORAGE],
      typeId: sourceTypeEnum.GOOGLE_CLOUD_STORAGE,
    },
  ],
  azure: [
    {
      text: sourceTextMapping[sourceTypeEnum.AZURE],
      typeId: sourceTypeEnum.AZURE,
    },
  ],
  web: [
    {
      text: sourceTextMapping[sourceTypeEnum.WEB_FOLDER],
      typeId: sourceTypeEnum.WEB_FOLDER,
    },
    {
      text: sourceTextMapping[sourceTypeEnum.WEB_PROXY],
      typeId: sourceTypeEnum.WEB_PROXY,
    },
  ],
  pim: [
    {
      text: sourceTextMapping[sourceTypeEnum.AKENEO_PIM],
      typeId: sourceTypeEnum.AKENEO_PIM,
    }
  ]
}

export const sourceFormFields: {
  [key: string]: Array<{
    fieldName: string
    label: string
    description?: string
    placeholder?: string
    required?: boolean
    info?: string
  }>
} = {
  GENERIC: [
    {
      fieldName: 'name',
      label: 'origin_name',
      description: 'origin_name_description',
      placeholder: 'e.g. - My Image Server',
      required: true,
    },
  ],
  [sourceTypeEnum.AMAZON_S3]: [
    {
      fieldName: 's3Bucket',
      label: 's3_bucket_name',
      info: 's3_bucket_info',
      required: true,
    },
    {
      fieldName: 's3Prefix',
      label: 's3_folder_name',
      info: 's3_folder_name_info',
      placeholder: "Eg - '/marketing-images'",
      required: true,
    },
    {
      fieldName: 's3AccessKey',
      label: 's3_access_key',
      info: 's3_key_info',
      required: true,
    },
    {
      fieldName: 's3SecretKey',
      label: 's3_secret_key',
      info: 's3_key_info',
      required: true,
    },
  ],
  [sourceTypeEnum.S3_COMPATIBLE_STORAGE]: [
    {
      fieldName: 's3Bucket',
      label: 'bucket_name',
      info: 'bucket_name_info',
      required: true,
    },
    {
      fieldName: 's3Prefix',
      label: 'bucket_folder',
      info: 'bucket_folder_info',
      placeholder: "Eg - '/marketing-images'",
      required: true,
    },
    {
      fieldName: 's3AccessKey',
      label: 'access_key',
      info: 's3_key_info',
      required: true,
    },
    {
      fieldName: 's3SecretKey',
      label: 'secret_key',
      info: 's3_key_info',
      required: true,
    },
    {
      fieldName: 'endpoint',
      label: 'endpoint',
      info: 'endpoint_info',
      placeholder: 'Eg - https://sgp1.digitaloceanspaces.com',
      required: true,
    },
  ],
  [sourceTypeEnum.CLOUDINARY_BACKUP]: [
    {
      fieldName: 's3Bucket',
      label: 'backup_bucket_name',
      info: 'backup_bucket_name_info',
      required: true,
    },
    {
      fieldName: 's3Prefix',
      label: 'backup_folder',
      info: 'bucket_folder_info',
      placeholder: "Eg - '/marketing-images'",
      required: true,
    },
    {
      fieldName: 's3AccessKey',
      label: 'bucket_access_key',
      info: 'cloudinary_secret_key_info',
      required: true,
    },
    {
      fieldName: 's3SecretKey',
      label: 'bucket_secret_key',
      info: 'cloudinary_secret_key_info',
      required: true,
    },
  ],
  [sourceTypeEnum.WEB_FOLDER]: [
    {
      fieldName: 'baseUrl',
      label: 'base_url',
      info: 'base_url_info',
      placeholder: 'Eg - http://mywebsite.com/images',
      required: true,
    },
  ],
  [sourceTypeEnum.WEB_PROXY]: [],
  [sourceTypeEnum.GOOGLE_CLOUD_STORAGE]: [
    {
      fieldName: 'bucketName',
      label: 'google_bucket_name',
      info: 'google_bucket_name_info',
      required: true,
    },
    {
      fieldName: 'googlePrefix',
      label: 'google_bucket_folder',
      info: 'google_bucket_folder_info',
      placeholder: "Eg - '/marketing-images'",
      required: true,
    },
    {
      fieldName: 'privateKey',
      label: 'google_private_key',
      info: 'google_private_key_info',
      placeholder:
        'Eg - -----BEGIN PRIVATE KEY-----MIIEvgIBADANBgkqhkiG9w0BAQEFAASCBKgwggSkAgEAAoIBAQCf1fT2G1y17+qCbBV',
      required: true,
    },
    {
      fieldName: 'clientEmail',
      label: 'google_client_email',
      info: 'google_client_email_info',
      placeholder: 'Eg - 2040-compp@developer.gserviceaccount.com',
      required: true,
      // hide: true,
    },
  ],
  [sourceTypeEnum.AZURE]: [
    {
      fieldName: 'containerName',
      label: 'azure_container_name',
      info: 'azure_container_name_info',
      required: true,
    },
    {
      fieldName: 'accountName',
      label: 'azure_account_name',
      info: 'azure_account_name_info',
      required: true,
    },
    {
      fieldName: 'azurePrefix',
      label: 'azure_container_folder',
      info: 'azure_container_folder_info',
      placeholder: "Eg - '/marketing-images'",
      required: true,
    },
    {
      fieldName: 'sasToken',
      label: 'azure_sas_token',
      info: 'azure_sas_token_info',
      placeholder:
        'Eg - ?sv=2019-12-12&ss=bfqt&srt=o&sp=rwdlacupx&se=2025-08-07T15:23:03Z&st=2020-08-07T07:23:03Z&spr=https&sig=su50YGKA3Jw2WOs3g3jOB0LWDbk%2Ba7006WDTWrn0U5A%3D',
      required: true,
    },
  ],
  [sourceTypeEnum.AKENEO_PIM]: [
    {
      fieldName: 'baseUrl',
      label: 'akeneo_baseUrl',
      info: 'akeneo_baseUrl_info',
      placeholder : 'Eg - https://youraccount.demo.akeneo.cloud',
      required: true,
    },
    {
      fieldName: 'clientId',
      label: 'akeneo_clientId',
      info: 'akeneo_clientId_info',
      required: true,
    },
    {
      fieldName: 'secret',
      label: 'akeneo_secret',
      info: 'akeneo_secret_info',
      required: true,
    },
    {
      fieldName: 'username',
      label: 'akeneo_username',
      info: 'akeneo_username_info',
      required: true,
    },
    {
      fieldName: 'password',
      label: 'akeneo_password',
      info: 'akeneo_password_info',
      required: true,
    }
  ],
}
